import { Component, OnDestroy, OnInit } from '@angular/core';
import { SweetAlertHelper } from 'app/core/helpers/sweet-alert-helper.service';
import { T2ThemeService } from 'app/trip2-theme/t2-theme.service';
import * as moment from 'moment';
import { Subscription } from 'rxjs';
import { MessageService } from 'app/core/services/message.service';
import { T2LoadingService } from 'app/trip2-theme/components/t2-loading/t2-loading.service';
import { EAlertMessageType } from 'app/core/enums/message.enum';
import { IProviderMessage } from 'app/core/interfaces/provider-message.interface';

@Component({
  selector: 'app-messages',
  templateUrl: './messages.component.html',
  styleUrls: ['./messages.component.scss'],
})

export class MessagesComponent implements OnInit, OnDestroy {
  subscriptions: Subscription[] = [];
  messages: IProviderMessage[] = [];

  constructor(
    private t2ThemeService: T2ThemeService,
    private sweetAlertHelper: SweetAlertHelper,
    private messageService: MessageService,
    private t2LoadingService: T2LoadingService
  ) {}

  ngOnInit() {
    this.loadAllMessages();
  }

  loadAllMessages(noloadMessages?: boolean) {
    this.subscriptions.push(
      this.t2ThemeService.getMessagesByUser().subscribe(
        (resp: IProviderMessage[]) => {
          if (resp && resp.length) {
            if (!noloadMessages) {
              this.showMessageModal(resp);
            }
            this.messages = resp;
          }
        },
        (error) => {
          this.sweetAlertHelper.createCustomAlert({
            title: 'Error',
            text: error.message,
            type: 'error',
          });
        }
      )
    );
  }

  showMessageModal(messages: IProviderMessage[]) {
    let existsMessage = messages.filter(
      (item) => item.messagetype === 'Popup' && !item.read
    );
    if (existsMessage && existsMessage.length) {
      this.sweetAlertHelper
        .createCustomAlert({
          title: `${existsMessage[0].subject} - ${this.formatteDate(
            existsMessage[0].startdate
          )}`,
          html: existsMessage[0].description,
          confirmButtonText: 'Mark as read',
          type: 'info',
          allowEscapeKey: false,
          allowOutsideClick: false,
        })
        .then((result) => {
          if (result.value || result.dismiss) {
            this.read(existsMessage[0].messageid);
            existsMessage.shift();
            if (existsMessage.length) {
              this.showMessageModal(existsMessage);
            }
          }
        });
    }
  }

  formatteDate(date: string) {
    const myDate = moment(date).format('MM/DD/YYYY');
    return myDate;
  }

  read(data: any, showSwal?: boolean): void {
    this.subscriptions.push(
      this.messageService.readMessage(data).subscribe(
        (resp: any) => {
          if (resp) {
            this.t2LoadingService.hiden();
            if (showSwal) {
              this.sweetAlertHelper
                .createCustomAlert({
                  title: 'Success',
                  text: resp.message,
                  type: 'success',
                })
                .then((result) => {
                  if (result.value || result.dismiss) {
                    this.loadAllMessages(true);
                  }
                });
            } else {
              this.loadAllMessages(true);
            }
          }
        },
        (error) => {
          this.t2LoadingService.hiden();
          this.sweetAlertHelper.createCustomAlert({
            title: 'Error',
            text: error.message,
            type: 'error',
          });
        }
      )
    );
  }

  verifyRead(read: boolean) {
    return read
      ? 'read-background colum-right'
      : 'not-read-background colum-right';
  }

  verifyMessageStatus(status: string) {
    return status !== 'Deleted' ? true : false;
  }

  verifyTypeAlert(type: number) {
    switch (type) {
      case EAlertMessageType.Info:
        return 'colum-left message-type-info';
      case EAlertMessageType.Warning:
        return 'colum-left message-type-warning';
      case EAlertMessageType.Danger:
        return 'colum-left message-type-danger';
      default:
        return 'colum-left message-type-info';
    }
  }

  getIcon(type: number) {
    switch (type) {
      case EAlertMessageType.Info:
        return 'fa fa-info';
      case EAlertMessageType.Warning:
        return 'fa fa-exclamation-triangle';
      case EAlertMessageType.Danger:
        return 'fa fa-bell-o';
      default:
        return 'fa fa fa-commenting-o';
    }
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription: Subscription) =>
      subscription.unsubscribe()
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/dashboard-providers/components/messages/messages.component.ts